import React from "react";
import { Loader } from "../common";

// Backwards compatibility wrapper for SectionLoader
const SectionLoader = (props) => (
  <Loader type="section" size="medium" {...props} />
);

export default SectionLoader;
